import { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_PORTFOLIO_API_KEY;

async function apiGet(path) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { "X-API-Key": API_KEY },
  });
  if (!res.ok) {
    throw new Error(`Request to ${path} failed with status ${res.status}`);
  }
  return res.json();
}

function apiPost(path, body) {
  // Fire-and-forget: tracking pings shouldn't ever block or break the page.
  return fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "X-API-Key": API_KEY, ...(body && { "Content-Type": "application/json" }) },
    ...(body && { body: JSON.stringify(body) }),
  }).catch((err) => console.error(`Tracking request to ${path} failed:`, err));
}

export const trackVisit = () => apiPost("/track/visit");
export const trackResumeDownload = () => apiPost("/track/resume-download");
export const trackBuildClick = (buildId) => apiPost("/track/build-click", { buildId });

export function useResume() {
  const [resumeUrl, setResumeUrl] = useState(null);

  useEffect(() => {
    apiGet("/resume")
      .then((data) => setResumeUrl(data.url))
      .catch((err) => console.error("Failed to load resume:", err));
  }, []);

  return resumeUrl;
}

export function useBuilds() {
  const [builds, setBuilds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiGet("/builds")
      .then((data) => {
        if (!cancelled) setBuilds(data.builds);
      })
      .catch((err) => console.error("Failed to load builds:", err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { builds, loading };
}

export function useDesigns() {
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiGet("/designs")
      .then((data) => {
        if (!cancelled) setDesigns(data.designs);
      })
      .catch((err) => console.error("Failed to load designs:", err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { designs, loading };
}

export function useAchievements() {
  const [achievements, setAchievements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiGet("/achievements")
      .then((data) => {
        if (!cancelled) setAchievements(data.achievements);
      })
      .catch((err) => console.error("Failed to load achievements:", err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { achievements, loading };
}

export function useCertifications() {
  const [certifications, setCertifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiGet("/certifications")
      .then((data) => {
        if (!cancelled) setCertifications(data.certifications);
      })
      .catch((err) => console.error("Failed to load certifications:", err))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { certifications, loading };
}
